import { useState, type FC } from "react";
import { MembersList } from "@/components/settings/organization/members/MembersList";
import { SearchInput } from "@/components/flexkit/SearchInput";
import { useMembers } from "@/queries/organization-queries";
import { useMembership } from "@/hooks/use-membership";
import { useAuthenticatedUser } from "@/queries/user-queries";
import { useDebounce } from "use-debounce";

export const MembersTab: FC = () => {
    const { data: user } = useAuthenticatedUser();
    const { membership } = useMembership();
    const [searchQuery, setSearchQuery] = useState("");

    const [debouncedSearchQuery] = useDebounce(searchQuery, 250, { trailing: true });
    const { data: membersData, isFetching: isMembersLoading } = useMembers({
        filter: {
            search: debouncedSearchQuery,
        },
    });

    return (
        <>
            <SearchInput
                wrapperClassName="w-full"
                className="max-w-none"
                placeholder="Search by name, email or ID"
                value={searchQuery || ""}
                onChange={(e) => setSearchQuery(e.target.value.trimStart().replace(/\s+/g, " "))}
                onClear={() => setSearchQuery("")}
                isLoading={isMembersLoading}
                data-tracking-id="search-members-input"
            />
            <MembersList
                user={user}
                membership={membership}
                data={{
                    members: membersData?.members || [],
                }}
                isLoading={isMembersLoading}
                hasSearchQuery={debouncedSearchQuery.trim().length > 0}
            />
        </>
    );
};
